import axiosInstance from './api'

/**
 * Fetch curriculum session completion progress for the authenticated counselor.
 * @param {{ grade?: number }} params - Optional grade filter (9–12).
 */
export const fetchCurriculumProgress = async ({ grade } = {}) => {
	try {
		const params =
			grade != null && Number.isFinite(Number(grade)) ? { grade } : {}
		const response = await axiosInstance.get('/counseling/curriculum/progress', {
			params,
		})
		return response.data
	} catch (error) {
		console.error('Error fetching curriculum progress:', error)
		throw error
	}
}

/**
 * Mark a curriculum session as complete.
 * @param {{ sessionId: string, grade?: number }} params
 */
export const markCurriculumSessionComplete = async ({ sessionId, grade }) => {
	try {
		const body = grade != null ? { grade: Number(grade) } : {}
		const response = await axiosInstance.post(
			`/counseling/curriculum/sessions/${encodeURIComponent(sessionId)}/complete`,
			body,
		)
		return response.data
	} catch (error) {
		console.error('Error marking curriculum session complete:', error)
		throw error
	}
}
